import { Button } from 'antd';
import classNames from 'classnames';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { saveAs } from 'file-saver';
import { useParams } from 'react-router';

import { FlexCol } from '../../components/layout/layoutElements';
import { useLayoutElementsStyles } from '../../components/layout/layoutElements.styles';
import BaseLoggedPage from '../../templates/BaseLoggedPage';
import { Spinner } from '../../components/data/Spinner';
import { useRichFetch } from '../../config/http';
import { useAsynchronousAction } from '../../components/data/asyncActionElements';
import { URLS } from '../../config/urls';
import { useFlashMessageContext } from '../../components/dialogs/FlashMessageProvider';
import { useDownloadStyles } from './Download.styles';

export default function DownloadReport() {
  const { styles } = useDownloadStyles();
  const { styles: layoutStyles } = useLayoutElementsStyles();
  const { errorMessage } = useFlashMessageContext();
  const { reportId } = useParams();
  const richFetch = useRichFetch();
  const { execute: download, loading: downloading } = useAsynchronousAction(
    async () => {
      try {
        const res = await richFetch(URLS.downloadReport(reportId), {
          method: 'GET',
        });
        const data = await res.blob();
        saveAs(data, res.headers.get('X-Filename'));
      } catch (e) {
        if (!e.handled) {
          errorMessage(e);
        }
      }
    }
  );

  useEffect(() => {
    if (!downloading) {
      download();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <BaseLoggedPage className={styles.downloadReportPage}>
      <FlexCol
        className={classNames(layoutStyles.flex1, styles.downloadReportContent)}
      >
        <FormattedMessage tagName="h1" id="downloading" />
        {downloading ? (
          <Spinner />
        ) : (
          <Button type="primary" size="large" onClick={download}>
            <FormattedMessage id="download" />
          </Button>
        )}
      </FlexCol>
    </BaseLoggedPage>
  );
}
